export const WIDGET_LEADERBOARD_TYPE = 'leaderboard';
